/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import classNames from "classnames";
import Image from "next/image";
import React, { useEffect, useMemo } from "react";
import cloudflareLoader from "@/lib/utils/cdn-cloudflare-loader";
import { placeholderImage } from "@/lib/utils/placeholder-image";
import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum';
import { useInfiniteImage } from "../../_hooks/useInfiniteImage";
import { useModal } from "../../_components/DpComponents/ModalProvider";
import SwiperWrapper from "../../_components/DpComponents/SwiperWrapper";
import { useSelectedTag } from "@/store/dpStore";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
const GallerySkeletonGrid = ({
  count = 9,
  className = ""
}) => <div className={classNames("grid grid-cols-3 gap-1 md:gap-4", className)}>
        {Array.from({
    length: count
  }).map((_, index) => <div key={index} className="relative w-full aspect-square">
                <Skeleton variant="rectangular" animation="wave" className="absolute inset-0" sx={{
      width: "100%",
      height: "100%"
    }} />
            </div>)}
    </div>;
export default function GalleryImagesNew({
  digitalProfile
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    setDigitalProfile
  } = useModal();
  const track = useInhomzTrack();
  const {
    selectedTag
  } = useSelectedTag();
  const {
    projectMediaGalleries,
    isLoading,
    isFetchingNextPage,
    loadMoreRef,
    totalElements
  } = useInfiniteImage(digitalProfile, selectedTag);
  const remainingImages = Math.max(0, totalElements - (projectMediaGalleries?.length ?? 0));
  const showScrollSkeleton = isFetchingNextPage && remainingImages > 1;
  const scrollSkeletonCount = Math.min(remainingImages, 6);
  const wrapperClasses = useMemo(() => classNames({
    "max-[640px]:px-[0px]": projectMediaGalleries?.length > 9
  }), [projectMediaGalleries?.length]);
  useEffect(() => {
    if (digitalProfile) {
      setDigitalProfile(digitalProfile);
    }
  }, [digitalProfile]);

  // function getGalleryAlbumId(gallery) {
  //     const attrs = gallery?.attributes;
  //     if (!attrs) return null;
  //     const albumRel = attrs.albums?.data?.[0];
  //     if (albumRel != null) {
  //         const id = albumRel.id ?? albumRel?.attributes?.id;
  //         if (id != null && id !== "") return id;
  //     }
  //     const albumObj = attrs.album;
  //     if (albumObj && typeof albumObj === "object" && !albumObj.data) {
  //         const id = albumObj.id;
  //         if (id != null && id !== "") return id;
  //     }
  //     if (attrs.album_id != null && attrs.album_id !== "") return attrs.album_id;
  //     if (typeof attrs.album === "number" || typeof attrs.album === "string") {
  //         return attrs.album;
  //     }
  //     return null;
  // }

  // remove albumBadge as removing album from DP
  // function AlbumOnImageBadge() {
  //     return (
  //         <div
  //             className="absolute bottom-1.5 left-1.5 z-[1] pointer-events-none flex items-center justify-center rounded-md text-[--colorPrimaryOnPrimary] p-[3px] shadow-sm"
  //             aria-hidden
  //         >
  //             <PhotoAlbumIcon sx={{ fontSize: 18 }} />
  //         </div>
  //     );
  // }

  return <div className={classNames("h-auto mb-2 md:mb-4 w-full", wrapperClasses)}>
            {isLoading ? <GallerySkeletonGrid /> : projectMediaGalleries?.length > 0 && <div className="grid grid-cols-3 gap-1">
                        {projectMediaGalleries.map((gallery, index) => {
        // const albumId = getGalleryAlbumId(gallery);
        // const showAlbumBadge = albumId != null && albumId !== "";

        return <div key={`${gallery?.id + index}-${gallery?.attributes?.media_url}`} className="aspect-square">
                                    <SwiperWrapper imageId={gallery?.id} onOpen={() => track(inhomzEvents.contractorProfile.GALLERY_IMG_CLICKED, {
            ...profileEventProps(digitalProfile),
            event_value: gallery?.id
          })}>
                                        <div className="relative w-full h-full border-white">
                                            <Image priority={index < 3} src={cloudflareLoader({
                src: gallery?.attributes?.media_url,
                width: isMobile ? 300 : 600,
                quality: 80
              })} alt="gallery_image" className="object-cover" placeholder={placeholderImage} unoptimized={true} sizes="100%" fill />
                                            {/* {showAlbumBadge && <AlbumOnImageBadge />} */}
                                        </div>
                                    </SwiperWrapper>
                                </div>;
      })}
                    </div>}

            <div ref={loadMoreRef} className="w-full" />

            {showScrollSkeleton && <GallerySkeletonGrid className="mt-1 md:mt-4" count={scrollSkeletonCount} />}
        </div>;
}